export default {
  id: '5a46bbec1f',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page mt" data-name="my-team">\r\n\r\n    <!-- Navbar -->\r\n    <div class="navbar mt__navbar no-shadow">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="left">\r\n          <a href="#" class="link back mt__back" aria-label="Back">\r\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\r\n          </a>\r\n        </div>\r\n        <div class="title mt__navbar-title">My Team</div>\r\n        <div class="right"></div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="page-content mt__content">\r\n\r\n      <!-- Team summary hero -->\r\n      <div class="mt__hero">\r\n        <span class="mt__hero-shine"></span>\r\n        <div class="mt__hero-glow"></div>\r\n        <div class="mt__hero-label">\r\n          <span class="mt__hero-label-ico">\r\n            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>\r\n          </span>\r\n          Total Team\r\n        </div>\r\n        <div class="mt__hero-amount mt-total-members">0</div>\r\n        <div class="mt__hero-sub">Members across all 20 levels</div>\r\n        <div class="mt__hero-foot">\r\n          <div class="mt__hero-tag">\r\n            <span class="mt__hero-tag-lbl">Team Business</span>\r\n            <span class="mt__hero-tag-val mt-team-business">$0.00</span>\r\n          </div>\r\n          <div class="mt__hero-tag">\r\n            <span class="mt__hero-tag-lbl">ROI Today</span>\r\n            <span class="mt__hero-tag-val mt__hero-tag-val--roi mt-team-roi">$0.00</span>\r\n          </div>\r\n          <div class="mt__hero-tag">\r\n            <span class="mt__hero-tag-lbl">Direct \xB7 L1</span>\r\n            <span class="mt__hero-tag-val mt-direct-members">0</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- View switch \xB7 flat level list vs. genealogy tree -->\r\n      <div class="mt__views">\r\n        <button type="button" class="mt__view-tab mt__view-tab--on" data-view="list">\r\n          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><circle cx="3.5" cy="6" r="1.4" fill="currentColor" stroke="none"/><circle cx="3.5" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="3.5" cy="18" r="1.4" fill="currentColor" stroke="none"/></svg>\r\n          <span>Level List</span>\r\n        </button>\r\n        <button type="button" class="mt__view-tab" data-view="tree">\r\n          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2.5" width="6" height="5" rx="1.4"/><rect x="2.5" y="16.5" width="6" height="5" rx="1.4"/><rect x="15.5" y="16.5" width="6" height="5" rx="1.4"/><path d="M12 7.5v4.5M5.5 16.5V12h13v4.5"/></svg>\r\n          <span>Genealogy</span>\r\n        </button>\r\n      </div>\r\n\r\n      <!-- \u2500\u2500 VIEW \xB7 flat level list \u2500\u2500 -->\r\n      <div class="mt__view mt__view--list">\r\n\r\n      <!-- Level filter -->\r\n      <div class="mt__sec-title">Filter by Level</div>\r\n      <div class="mt__lvl-select">\r\n        <select class="mt__lvl-native" id="mtLevelSelect">\r\n          <option>Loading levels\u2026</option>\r\n        </select>\r\n      </div>\r\n\r\n      <!-- Selected level stats -->\r\n      <div class="mt__lvl-stats">\r\n        <div class="mt__lvl-stat">\r\n          <span class="mt__lvl-stat-val mt-lvl-members">0</span>\r\n          <span class="mt__lvl-stat-lbl">Members</span>\r\n        </div>\r\n        <div class="mt__lvl-stat">\r\n          <span class="mt__lvl-stat-val mt-lvl-active">0</span>\r\n          <span class="mt__lvl-stat-lbl">Active Investors</span>\r\n        </div>\r\n        <div class="mt__lvl-stat">\r\n          <span class="mt__lvl-stat-val mt__lvl-stat-val--roi mt-lvl-roi">$0</span>\r\n          <span class="mt__lvl-stat-lbl">ROI Today</span>\r\n        </div>\r\n        <div class="mt__lvl-stat">\r\n          <span class="mt__lvl-stat-val mt-lvl-volume">$0</span>\r\n          <span class="mt__lvl-stat-lbl">Level Volume</span>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Members -->\r\n      <div class="mt__sec-title"><span class="mt__members-title">Direct Members</span></div>\r\n      <div class="all-teams--list mt__members"></div>\r\n      <button type="button" class="mt__loadmore" style="display:none;">\r\n        Load More Members\r\n        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="6 9 12 15 18 9"/></svg>\r\n      </button>\r\n\r\n      </div><!-- /mt__view--list -->\r\n\r\n      <!-- \u2500\u2500 VIEW \xB7 genealogy tree (children fetched on demand, never all at once) \u2500\u2500 -->\r\n      <div class="mt__view mt__view--tree" style="display:none;">\r\n        <div class="mt__sec-title mt__tree-sec">\r\n          <span>Genealogy</span>\r\n          <button type="button" class="mt__tree-collapse mt__gen-up" style="display:none;">\r\n            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="15 18 9 12 15 6"/></svg>\r\n            Back\r\n          </button>\r\n        </div>\r\n        <p class="mt__tree-hint">Tap a member to open their line. Each level loads only when you reach it.</p>\r\n        <div class="mt__tree"></div>\r\n      </div>\r\n\r\n      <!-- Referral share -->\r\n      <div class="mt__refer">\r\n        <div class="mt__refer-glow"></div>\r\n        <div class="mt__refer-top">\r\n          <div class="mt__refer-emblem">\r\n            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>\r\n          </div>\r\n          <div class="mt__refer-head">\r\n            <div class="mt__refer-title">Grow Your Team</div>\r\n            <div class="mt__refer-sub">Share your code &amp; earn Team ROI Bonus</div>\r\n          </div>\r\n        </div>\r\n        <div class="mt__code-box">\r\n          <span class="mt__code-label">CODE</span>\r\n          <span class="referral-code mt__code" id="referralCode">\u2014\u2014</span>\r\n          <button type="button" class="copy-icon mt__copy" title="Copy Referral Code" aria-label="Copy">\r\n            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>\r\n          </button>\r\n        </div>\r\n        <button type="button" class="invite-link-btn mt__invite">\r\n          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>\r\n          Invite Friends\r\n        </button>\r\n      </div>\r\n\r\n      <div class="mt__end-gap"></div>\r\n    </div>\r\n\r\n    <!-- \u2550\u2550 BOTTOM NAVIGATION \u2550\u2550 -->\r\n    <div class="toolbar toolbar-bottom hp__bar no-shadow">\r\n      <div class="toolbar-inner hp__bar-inner">\r\n        <a href="/" class="hp__tab">\r\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/></svg>\r\n          <span>Dashboard</span>\r\n        </a>\r\n        <a href="/invest-dashboard/" class="hp__tab item__link--portfolio">\r\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>\r\n          <span>Portfolio</span>\r\n        </a>\r\n        <a href="/my-team/" class="hp__tab hp__tab--center hp__tab--on item__link--team">\r\n          <span class="hp__tab-fab">\r\n            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>\r\n          </span>\r\n          <span>Team</span>\r\n        </a>\r\n        <a href="/earning/" class="hp__tab item__link--rewards">\r\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>\r\n          <span>Rewards</span>\r\n        </a>\r\n        <a href="#" class="hp__tab profile-link popup-open" data-popup="#profile-popup">\r\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>\r\n          <span>Profile</span>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
/* ════════ MY TEAM PAGE (mt__*) ════════ */
.mt { background: #0A0A0B !important; }
.mt__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.mt__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.mt__navbar .navbar-bg { background: transparent !important; }
.mt__navbar-title { color: var(--gold) !important; font-weight: 700; }
.mt__back { color: rgba(201,169,105,0.85) !important; }

/* ── Hero ── */
.mt__hero {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(201,169,105,0.18) 0%, transparent 55%),
    linear-gradient(150deg, #221b0d 0%, #161109 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 22px; padding: 20px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 16px 36px -18px rgba(0,0,0,0.8);
}
.mt__hero::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
@keyframes mt-shine { 0% { transform: translateX(-130%) skewX(-18deg); } 100% { transform: translateX(420%) skewX(-18deg); } }
.mt__hero-shine {
  position: absolute; top: 0; bottom: 0; width: 40%; pointer-events: none;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent);
  animation: mt-shine 5.5s ease-in-out infinite 1.5s;
}
.mt__hero-glow {
  position: absolute; top: -50px; right: -40px; width: 170px; height: 170px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%);
}
.mt__hero-label {
  position: relative; z-index: 1; display: flex; align-items: center; gap: 9px;
  font-size: 11.5px; font-weight: 600; color: rgba(255,255,255,0.55);
  text-transform: uppercase; letter-spacing: 0.06em;
}
.mt__hero-label-ico {
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
  width: 30px; height: 30px; border-radius: 9px; color: #dfc288;
  background: linear-gradient(145deg, rgba(201,169,105,0.22), rgba(201,169,105,0.05));
  border: 1px solid rgba(201,169,105,0.28);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.12), 0 5px 12px -5px rgba(201,169,105,0.45);
}
.mt__hero-amount { position: relative; z-index: 1; font-size: 34px; font-weight: 800; color: #fff; letter-spacing: -0.02em; line-height: 1; margin: 9px 0 6px; }
.mt__hero-sub { position: relative; z-index: 1; font-size: 12px; color: rgba(255,255,255,0.5); }
.mt__hero-foot { position: relative; z-index: 1; display: flex; gap: 10px; margin-top: 16px; }
.mt__hero-tag { flex: 1; padding: 10px 12px; border-radius: 12px; background: rgba(0,0,0,0.22); border: 1px solid rgba(201,169,105,0.14); }
.mt__hero-tag-lbl { display: block; font-size: 10px; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.03em; }
.mt__hero-tag-val { display: block; font-size: 15px; font-weight: 800; color: #fff; margin-top: 3px; }
.mt__hero-tag-val--roi { color: #4ade80; }

/* ── Section title ── */
.mt__sec-title { font-size: 12px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: rgba(201,169,105,0.65); margin: 22px 4px 11px; }

/* ════════ View switch (List · Genealogy) ════════ */
.mt__views {
  display: flex; gap: 4px; margin-top: 16px; padding: 4px;
  background: rgba(0,0,0,0.32);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 14px;
}
.mt__view-tab {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px;
  height: 38px; border: none; border-radius: 11px; cursor: pointer;
  background: transparent; color: rgba(255,255,255,0.42);
  font-size: 12px; font-weight: 700; letter-spacing: 0.01em;
  transition: background .2s ease, color .2s ease, box-shadow .2s ease;
}
.mt__view-tab--on {
  background: linear-gradient(150deg, rgba(201,169,105,0.24), rgba(201,169,105,0.08));
  color: #f3e0a8;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.22), 0 6px 14px -10px rgba(201,169,105,0.7);
}

/* ════════ Genealogy tree (mt__node*) ════════ */
.mt__tree-sec { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.mt__tree-sec > span { flex: 1 1 auto; min-width: 0; }
/* flex:0 0 auto — without it the button is a stretchable flex item and fills the row */
.mt__tree-collapse {
  flex: 0 0 auto; width: auto; align-self: center;
  display: inline-flex; align-items: center; justify-content: center; gap: 5px;
  padding: 5px 11px 5px 8px; border-radius: 20px; cursor: pointer;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.30);
  color: rgba(223,194,136,0.95); font-size: 10.5px; font-weight: 700;
  text-transform: none; letter-spacing: 0; line-height: 1;
}
.mt__tree-collapse:active { background: rgba(201,169,105,0.22); }
.mt__tree-hint { font-size: 11px; color: rgba(255,255,255,0.36); line-height: 1.5; margin: -4px 4px 12px; }
.mt__tree {
  position: relative;
  background: linear-gradient(158deg, #17150F 0%, #121110 60%, #141210 100%);
  border: 1px solid rgba(201,169,105,0.18);
  border-radius: 18px; padding: 12px 12px 14px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.12), 0 16px 34px -24px rgba(0,0,0,0.85);
}
.mt__tree-load { font-size: 11.5px; color: rgba(255,255,255,0.36); padding: 9px 4px 9px 12px; }
.mt__tree-load--err { color: rgba(251,191,36,0.8); }

/* ── round preloader ── */
@keyframes mt-spin { to { transform: rotate(360deg); } }
.mt__spin-wrap { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 26px 0 22px; }
.mt__spin {
  width: 28px; height: 28px; border-radius: 50%;
  border: 2.5px solid rgba(201,169,105,0.16);
  border-top-color: #dfc288;
  animation: mt-spin .7s linear infinite;
}
.mt__spin-txt { font-size: 11px; color: rgba(255,255,255,0.34); letter-spacing: 0.02em; }
.mt__spin-txt::after { content: '…'; }

/* ── breadcrumb spine ── */
/* wrapper carries the right-edge fade so a long trail reads as scrollable */
.mt__crumbs-wrap {
  position: relative;
  padding-bottom: 9px; margin-bottom: 11px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.mt__crumbs-wrap::after {
  content: ''; position: absolute; right: 0; top: 0; bottom: 9px; width: 26px;
  pointer-events: none;
  background: linear-gradient(90deg, transparent, #15130E);
}
.mt__crumbs {
  display: flex; align-items: center; gap: 2px; min-height: 26px;
  overflow-x: auto; -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.mt__crumbs::-webkit-scrollbar { display: none; }
.mt__crumb {
  flex: 0 0 auto; width: auto;
  display: inline-flex; align-items: center; gap: 5px;
  padding: 3px 9px 3px 3px; border-radius: 20px; cursor: pointer;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.55); font-size: 10.5px; font-weight: 700;
  white-space: nowrap;
  transition: background .18s ease, color .18s ease, border-color .18s ease;
}
.mt__crumb img { width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0; }
.mt__crumb-l {
  font-size: 8px; font-weight: 800; letter-spacing: 0.04em;
  padding: 1px 4px; border-radius: 5px;
  background: rgba(0,0,0,0.34); color: rgba(223,194,136,0.75);
}
.mt__crumb--on {
  background: linear-gradient(150deg, rgba(201,169,105,0.28), rgba(201,169,105,0.10));
  border-color: rgba(201,169,105,0.48); color: #f3e0a8;
}
.mt__crumb--on .mt__crumb-l { color: #f3e0a8; }
/* ancestors that were never visited (jumped straight to a deep member) */
.mt__crumb--gap {
  padding: 3px 9px; cursor: default; color: rgba(255,255,255,0.34);
  letter-spacing: 0.12em;
}
.mt__crumb-sep { flex: 0 0 auto; color: rgba(255,255,255,0.20); }

/* ── focused member ── */
.mt__focus {
  position: relative; display: flex; align-items: center; gap: 11px;
  padding: 12px; border-radius: 15px;
  background: linear-gradient(150deg, rgba(201,169,105,0.20), rgba(201,169,105,0.05));
  border: 1px solid rgba(201,169,105,0.38);
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20);
}
.mt__focus-av { width: 42px; height: 42px; border-radius: 50%; flex-shrink: 0; box-shadow: 0 0 0 1.5px rgba(223,194,136,0.45); }
.mt__focus-dot {
  position: absolute; left: 43px; top: 42px;
  width: 9px; height: 9px; border-radius: 50%; border: 2px solid #17150F;
}
.mt__focus-dot--on { background: #4ade80; }
.mt__focus-dot--off { background: rgba(255,255,255,0.24); }
.mt__focus-body { flex: 1; min-width: 0; }
.mt__focus-name {
  display: flex; align-items: center; gap: 7px;
  font-size: 15px; font-weight: 800; color: #fff; letter-spacing: -0.01em;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.mt__focus-meta { font-size: 10.5px; color: rgba(223,194,136,0.62); margin-top: 3px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mt__focus-inv { flex-shrink: 0; text-align: right; }
.mt__focus-inv span { display: block; font-size: 14px; font-weight: 800; color: #dfc288; font-variant-numeric: tabular-nums; }
.mt__focus-inv small { display: block; font-size: 8.5px; color: rgba(255,255,255,0.34); text-transform: uppercase; letter-spacing: 0.05em; margin-top: 2px; }
.mt__lvl-chip {
  flex-shrink: 0; font-size: 9px; font-weight: 800; letter-spacing: 0.05em;
  padding: 2px 7px; border-radius: 20px;
  background: rgba(0,0,0,0.35); color: rgba(223,194,136,0.9); border: 1px solid rgba(201,169,105,0.3);
}
.mt__node-you {
  flex-shrink: 0; font-size: 8.5px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase;
  padding: 2px 7px; border-radius: 20px; color: #1a1206;
  background: linear-gradient(145deg, #f6e3a8, #a07c38);
}

/* ── children list · full width at every depth ── */
.mt__gen-head { display: flex; align-items: baseline; gap: 7px; margin: 15px 2px 8px; }
.mt__gen-head-t { font-size: 10.5px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: rgba(201,169,105,0.6); }
.mt__gen-head-n { font-size: 10.5px; font-weight: 800; color: rgba(255,255,255,0.35); }
.mt__gen-head-n:empty { display: none; }
.mt__gen-list { display: flex; flex-direction: column; gap: 6px; }
.mt__row {
  width: 100%; display: flex; align-items: center; gap: 10px; text-align: left;
  padding: 9px 10px; border-radius: 12px; cursor: default;
  background: linear-gradient(155deg, rgba(255,255,255,0.045), rgba(255,255,255,0.012));
  border: 1px solid rgba(255,255,255,0.06);
  transition: background .18s ease, border-color .18s ease, transform .12s ease;
}
.mt__row--open { cursor: pointer; }
.mt__row--open:active { transform: scale(0.985); background: rgba(201,169,105,0.10); border-color: rgba(201,169,105,0.30); }
.mt__row-avwrap { position: relative; flex-shrink: 0; }
.mt__row-av { width: 34px; height: 34px; border-radius: 50%; display: block; }
.mt__row-dot {
  position: absolute; right: -1px; bottom: -1px;
  width: 9px; height: 9px; border-radius: 50%; border: 2px solid #151311;
}
.mt__row-dot--on { background: #4ade80; }
.mt__row-dot--off { background: rgba(255,255,255,0.22); }
.mt__row-body { flex: 1; min-width: 0; display: block; }
.mt__row-name {
  display: block; font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.94);
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.mt__row-meta {
  display: block; font-size: 10px; color: rgba(255,255,255,0.36); margin-top: 2px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.mt__row-right { flex-shrink: 0; display: flex; align-items: center; gap: 8px; }
.mt__row-inv { font-size: 12.5px; font-weight: 800; color: #dfc288; font-variant-numeric: tabular-nums; }
.mt__row-go {
  width: 20px; height: 20px; border-radius: 7px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.12); color: rgba(201,169,105,0.85);
}
.mt__row-go--leaf { background: transparent; }
.mt__row-go--leaf::after { content: ''; width: 4px; height: 4px; border-radius: 50%; background: rgba(255,255,255,0.14); }

/* ── Level filter (select2 dropdown) ── */
.mt__lvl-select { position: relative; }
.mt__lvl-select .select2-container { width: 100% !important; }
/* native fallback (only visible if select2 fails to load) */
.mt__lvl-native {
  width: 100%; height: 48px; padding: 0 16px; border-radius: 14px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.25); color: #fff;
  font-size: 14px; font-weight: 700; outline: none; cursor: pointer;
}
.mt__lvl-native option { background: #161513; color: #fff; font-weight: 600; }

/* ── Selected level stats ── */
.mt__lvl-stats {
  display: grid; grid-template-columns: 1fr 1fr; gap: 1px; margin-top: 12px;
  background: rgba(201,169,105,0.1); border: 1px solid rgba(201,169,105,0.14);
  border-radius: 16px; overflow: hidden;
}
.mt__lvl-stat { text-align: center; min-width: 0; padding: 15px 8px; background: linear-gradient(155deg, #161513 0%, #121110 100%); }
.mt__lvl-stat-val { display: block; font-size: 19px; font-weight: 800; color: #fff; line-height: 1; }
.mt__lvl-stat-val--roi { color: #4ade80; }
.mt__lvl-stat-lbl { display: block; font-size: 10px; color: rgba(255,255,255,0.45); margin-top: 5px; text-transform: uppercase; letter-spacing: 0.02em; }
.mt__lvl-sep { width: 1px; height: 30px; background: rgba(255,255,255,0.08); }

/* ── Member cards ── */
.mt__members { margin-top: 2px; }
.mt__member {
  display: flex; align-items: flex-start; gap: 12px; margin-bottom: 10px; padding: 13px 14px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.12); border-radius: 15px;
}
.mt__member-avatar { width: 44px; height: 44px; border-radius: 50%; flex-shrink: 0; border: 1.5px solid rgba(201,169,105,0.3); }
.mt__member-body { flex: 1; min-width: 0; }
.mt__member-top { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.mt__member-name { font-size: 14px; font-weight: 700; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.mt__member-inv { flex-shrink: 0; font-size: 13.5px; font-weight: 800; color: #dfc288; }
.mt__member-uname { font-size: 11.5px; font-weight: 600; color: rgba(201,169,105,0.72); margin-top: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.mt__member-email { font-size: 11.5px; color: rgba(255,255,255,0.45); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.mt__member-meta { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
.mt__member-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 3px 8px; border-radius: 7px; font-size: 10.5px; font-weight: 600;
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.07); color: rgba(255,255,255,0.55);
}
.mt__member-chip svg { color: rgba(201,169,105,0.7); }
.mt__chip-dot { width: 5px; height: 5px; border-radius: 50%; }
.mt__member-chip--active { background: rgba(74,222,128,0.12); border-color: rgba(74,222,128,0.24); color: #4ade80; }
.mt__member-chip--active .mt__chip-dot { background: #4ade80; }
.mt__member-chip--inactive { background: rgba(255,107,92,0.12); border-color: rgba(255,107,92,0.24); color: #ff6b5c; }
.mt__member-chip--inactive .mt__chip-dot { background: #ff6b5c; }

/* load more */
.mt__loadmore {
  width: 100%; height: 46px; margin-top: 4px; border-radius: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.22);
  color: var(--gold); font-size: 13px; font-weight: 700;
}
.mt__loadmore:active { transform: scale(0.99); }

/* loading / empty */
.mt__loading { text-align: center; padding: 34px 20px; color: rgba(255,255,255,0.45); font-size: 13px; }
.mt__empty { text-align: center; padding: 36px 20px; }
.mt__empty-ico {
  width: 64px; height: 64px; border-radius: 50%; margin: 0 auto 14px;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.18); color: rgba(201,169,105,0.7);
  display: flex; align-items: center; justify-content: center;
}
.mt__empty-title { font-size: 15px; font-weight: 700; color: rgba(255,255,255,0.85); margin: 0; }
.mt__empty-sub { font-size: 12px; color: rgba(255,255,255,0.45); margin: 6px 0 0; line-height: 1.55; }

/* ── Referral ── */
.mt__refer {
  position: relative; overflow: hidden; margin-top: 18px;
  background: linear-gradient(155deg, #1a1610 0%, #121010 100%);
  border: 1px solid rgba(201,169,105,0.2); border-radius: 20px; padding: 16px;
}
.mt__refer-glow { position: absolute; top: -40px; right: -30px; width: 130px; height: 130px; border-radius: 50%; pointer-events: none; background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%); }
.mt__refer-top { position: relative; z-index: 1; display: flex; align-items: center; gap: 12px; }
.mt__refer-emblem { width: 42px; height: 42px; border-radius: 12px; flex-shrink: 0; background: rgba(201,169,105,0.1); border: 1px solid rgba(201,169,105,0.22); display: flex; align-items: center; justify-content: center; }
.mt__refer-title { font-size: 14.5px; font-weight: 800; color: #fff; }
.mt__refer-sub { font-size: 11.5px; color: rgba(255,255,255,0.5); margin-top: 2px; }
.mt__code-box { position: relative; z-index: 1; display: flex; align-items: center; gap: 10px; margin-top: 14px; padding: 0 6px 0 14px; height: 50px; border-radius: 13px; background: rgba(0,0,0,0.28); border: 1px dashed rgba(201,169,105,0.4); }
.mt__code-label { font-size: 10px; font-weight: 700; color: rgba(201,169,105,0.7); letter-spacing: 0.08em; }
.mt__code { flex: 1; min-width: 0; font-size: 17px; font-weight: 800; color: #dfc288; letter-spacing: 0.06em; }
.mt__copy { width: 38px; height: 38px; border-radius: 10px; flex-shrink: 0; background: rgba(201,169,105,0.12); border: none; color: #C9A969; display: flex; align-items: center; justify-content: center; }
.mt__copy:active { transform: scale(0.92); }
.mt__invite {
  position: relative; z-index: 1; width: 100%; height: 48px; margin-top: 12px; border: none; border-radius: 13px;
  display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 14px; font-weight: 800;
  box-shadow: 0 10px 24px -10px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
}
.mt__invite:active { transform: scale(0.98); }

.mt__end-gap { height: 96px; }
`,
  styleScoped: false
};